$(function() {
  if ($('.video-section .parallax-banner .bcg')) {
    $(window).resize(function () {
      updateHeroHeight();
    });    
    
    // Call function when document is loaded
    updateHeroHeight();
  }

  function updateHeroHeight() {
    
    // save min size of hero
    $('.video-section').css('min-height', '350px');
    $('.video-section .parallax-banner .homepage-video--media .hsContainer').css('min-height', '350px');
    $('.video-section .parallax-banner .homepage-video--media .hsContainer .mediaWrapper iframe').css('min-height', '350px');
    
    // set position of the back image
    $('.video-section').css('top', 0);
    $('.video-section .parallax-banner .homepage-video--media .hsContainer').css('top', 0);
    
    // get size of header
    var heightNav = 0;
    //var heightNav = $('.header').height();        
    
        
    // set the height of the hero
    
    // if we're on mobile, set the height to equal the fallback image's native height. 
    if($(window).width() < 768) {
      var imageHeight = $(window).height() - heightNav - 390;
      var image = $('.video-section .parallax-banner .homepage-video--media .hsContainer img');
      
      $('.video-section').css('min-height', '200px');
      $('.video-section .parallax-banner .homepage-video--media .hsContainer').css('min-height', '200px');
      $('.video-section .parallax-banner .homepage-video--media .hsContainer .mediaWrapper iframe').css('min-height', '200px');
      
      if (image.length && image.first().height()) {
      	imageHeight = image.first().height();
      } 
      $('.video-section').css('height', imageHeight);
      
    } else if($(window).width() < 950)
    	$('.video-section').css('height', $(window).height() - heightNav - 390);   
    else
    	$('.video-section').css('height', $(window).height() - heightNav - 440);   
    
    
	// test the size of the website to change the max height
    //if ($(window).width() > 480) {
      //$('.homepage_slider').css('max-height', $(window).height() - heightNav - $('.collection-list-section').height() - 70);
    //} else {
      //$('.homepage_slider').css('max-height', '390px');
    //}

    // set the height of the back image to same the hero div
    //if ($('.video-section').height() > $('.video-section .parallax-banner .homepage-video--media .hsContainer').height()) {
      $('.video-section .parallax-banner .homepage-video--media .hsContainer').height($('.video-section').height());
      $('.video-section .parallax-banner .homepage-video--media .hsContainer').width('auto');
    
    //}	
  } 
});


